<template>
  <RuesBoxSize :size="props.item?.width">
    <div
      role="search"
      :class="['text-left grid grid-cols-1 lg:grid-cols-6', {'gap-x-3 gap-y-3' : !ruesSearchbar}, {'gap-y-0' : ruesSearchbar}]"
    >
      <div :class="['col-span-1 lg:col-span-2', {'lg:border-r border-neutral-200 border-b lg:border-b-0 pr-0 lg:pr-2' : ruesSearchbar}]">
        <SearchFilterLocation :params="searchParams" :design="ruesSearchbar ? 'ruesSearchbar' : ''" :update-on-input="true" @update="update($event)" />
      </div>
      <div :class="['col-span-1 lg:col-span-2 rues-travel-dates', {'border-neutral-200 border-b lg:border-b-0 px-0 lg:px-2' : ruesSearchbar}]">
        <SearchFilterTravelDates :params="searchParams" :design="ruesSearchbar ? 'ruesSearchbar' : ''" @update="update($event)" />
      </div>
      <div :class="['col-span-1 rues-travel-guests', {'lg:border-l border-neutral-200 pl-0 lg:pl-2' : ruesSearchbar}]">
        <SearchFilterGuestsBedroomsPets :params="searchParams" :design="ruesSearchbar ? 'ruesSearchbar' : ''" @update="update($event)" />
      </div>
      <div :class="['col-span-1 px-3 lg:px-0', {'pl-3 lg:pl-2 pt-2 lg:pt-0' : ruesSearchbar}]">
        <UiMaskedLink :href="'/search/' + hashParams" :new-tab="false" class="h-full">
          <UiButton color="cta" class="w-full h-full min-h-[50px]" @click="save">
            <span v-show="!activeSpinner" class="flex justify-center items-center gap-x-2">
              <UiIcon src="/svg/icons/magnifying-glass.svg" width="17" height="17" alt="Lupe Icon" class="stroke-white inline-block flex-none" />
              <UiLanguagePlaceholder domain="RuesSearch" name="search" />
            </span>
            <span v-show="activeSpinner">
              <UiSpinner design="spinner" :width="35" :height="35" />
            </span>
          </UiButton>
        </UiMaskedLink>
      </div>
    </div>
  </RuesBoxSize>
</template>

<script setup lang="ts">
import type { ComputedRef } from 'vue'
import { useSearchParamsStore } from '~/stores/searchParams'
import UrlHashSearchParams from '~/utils/search/UrlHashSearchParams'

const searchParamsStore = useSearchParamsStore()
const urlHashSearchParams = new UrlHashSearchParams()
const { currentPortal } = usePortals()
const config = currentPortal.value.search_form
const activeSpinner: Ref<boolean> = ref(false)
const props = defineProps({
  item: {
    type: Object,
    default: null
  },
  design: {
    type: String,
    default:''
  }
})
const ruesSearchbar = computed(() => props.design === 'ruesSearchbar')
// TODO: Remove this commented-out code:
// searchParamsStore.von = ''
// searchParamsStore.bis = ''
searchParamsStore.resetToDefaultState()

const searchParams = reactive(searchParamsStore.getClonedDefaultState())
searchParams.ort = String(props.item?.params?.sf_ort !== undefined && props.item?.params?.sf_ort !== '' ? props.item.params.sf_ort : (config.appearance === 'select' ? props.item?.region || '' : props.item?.region_name || ''))
const hashParams: ComputedRef<string> = computed(() => {
  const hashParamsString = urlHashSearchParams.convertSearchParamsToHashParamsString(searchParamsStore.activeFilters)
  if (hashParamsString === undefined || typeof hashParamsString !== 'string') {
    return ''
  }
  return hashParamsString
})
const update = (event) => {
  Object.entries(event).forEach(([key, value]) => {
    searchParams[key] = value
  })
}
const save = () => {
  activeSpinner.value = true
  const mergedParams = {
    ...searchParams,
    ...props.item?.params
  }
  searchParamsStore.resetToDefaultState()
  searchParamsStore.$patch(mergedParams)
}
onMounted(() => {
  activeSpinner.value = false
  window.addEventListener('pageshow', () => {
    activeSpinner.value = false
  })
})
</script>

<style>
@reference "~/assets/css/main.css";
.rues-travel-dates, .rues-travel-guests{
  &> div{
    @apply w-full;
    margin: 0 !important;
    border: 0 !important;
  }
}
</style>
